import { ATDLNOperator } from "../enums/atdl-operator.enum";

export class ATDLValidationRuleModel {
  public field: string = null;
  public field2: string = null;
  public value: string = null;
  public operator: ATDLNOperator = null;

  constructor(field?: string, operator?: ATDLNOperator) {
    this.field = field;
    this.operator = operator;
  }
}
